     document.addEventListener('DOMContentLoaded', function () {
        const notifyBtn = document.getElementById('notify-btn');
        const modal = document.getElementById('restock-modal');
        const closeBtn = document.querySelector('.restock-close');
        const overlay = document.querySelector('.restock-modal-overlay');
        const form = document.getElementById('restock-form');
        const message = document.getElementById('restock-message');
        const submitButton = form?.querySelector('button[type="submit"]');

        //Scroll Function
        function disableBodyScroll() {
        // Save current scroll position
        const scrollY = window.scrollY;

        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';

        // Store it for later
        document.body.dataset.scrollY = scrollY;
        }

        function enableBodyScroll() {
        const scrollY = document.body.dataset.scrollY || '0';

        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';

        // Restore original scroll position
        window.scrollTo(0, parseInt(scrollY, 10));
        }


        //Refresh Logic and submission

        notifyBtn?.addEventListener('click', function () {
            modal.style.display = 'flex';
            disableBodyScroll();
        });

        closeBtn?.addEventListener('click', function () {
            modal.style.display = 'none';
            enableBodyScroll();
        });

        overlay?.addEventListener('click', function () {
            modal.style.display = 'none';
            enableBodyScroll();
        });


        //Before submit
        form?.addEventListener('submit', function () {

            if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = 'Submitting...';
            }

            // Save current position so we can return here later
            sessionStorage.setItem('restock_scroll_position', window.scrollY);

            // Flag to show success message after redirect
            sessionStorage.setItem('restock_success', 'true');
        });


    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    sessionStorage.setItem('restock_success', 'true');

            const url = new URL(window.location.href);

    const isSuccess =
      sessionStorage.getItem('restock_success') === 'true' &&
      url.searchParams.get('customer_posted') === 'true';

    if (isSuccess) {

      sessionStorage.removeItem('restock_success');

      // Clean URL immediately (prevents anchor jump rendering)
      window.history.replaceState(
        {},
        document.title,
        window.location.pathname
      );

      // Lock scroll instantly before browser paints anything
      window.scrollTo(0, 0);

      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
      });

      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 0);

      // Show modal + success state
      if (modal) modal.style.display = 'flex';
      if (form) form.style.display = 'none';

      if (message) {
        message.style.display = 'block';
        message.style.color = 'green';
        message.textContent =
          "Thank you! We'll notify you when BuzzKill™ is back in stock.";
      }

      // Final cleanup after delay
      setTimeout(() => {

        enableBodyScroll();

        window.location.replace(window.location.pathname);

      }, 2500);
    }
        });